import { fetchDataSupplier } from "../../services/supplierService";
import { saveProfileSystem } from "../../services/profileSystemService";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ComboboxComponent from "../Combobox";
import TranslationKeySelect from "../TranslationKeySelect";
import ImageCropModal from "../ImageCropModal";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ToggleWithLabel from "../ToggleWithLabel";
import TranslationTable from "../TranslationTable";
import {
  XMarkIcon,
  TrashIcon,
  PlusIcon,
} from "@heroicons/react/20/solid";
import { Dialog, Transition } from "@headlessui/react";
import TreeSelectComponent from "../TreeSelectComponent";
import saveItem, { getItem, getList } from "../../services/service";
import React, { Fragment, useEffect, useRef, useState } from "react";

const VISIBILITY_OPTIONS = ["PUBLIC", "PRIVATE"];

/** Backend sozlamaguncha ishlatiladigan zaxira ro'yxat (enum endpointi javob bermasa). */
const SLIDING_TYPE_FALLBACK = ["NONE", "FRAME_PER_TRACK", "MULTI_TRACK_FRAME"];

/** Backend javob bermasa ishlatiladigan zaxira ro'yxat: ALL — v1 va v2, V2_ONLY — faqat yangi web-ui. */
const CLIENT_SCOPE_FALLBACK = ["ALL", "V2_ONLY"];

/** Sash zazori bo'sh bo'lsa backend ishlatadigan global qiymat (sash.clearance). */
const DEFAULT_SASH_CLEARANCE = 12;

/** FRAME_PER_TRACK uchun tavsiya etilgan maksimal rama soni. */
const DEFAULT_MAX_TRACK_COUNT = 5;

const PLACEHOLDER_IMAGE =
  "https://e7.pngegg.com/pngimages/641/399/png-clipart-upload-directory-document-document-file-up-upload-icon-miscellaneous-angle.png";

const PROFILE_SYSTEM_TRANSLATION_FIELDS = [
  { key: "NAME", label: "Nomi (name)" },
];

export default function ModalAddProfileSystem({
  open,
  setOpen,
  fetchData,
  rowId,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const cancelButtonRef = useRef(null);
  const translationRef = useRef(null);
  const { token } = useSelector((state) => state.user);
  const [name, setName] = useState("");
  const [parentId, setParentId] = useState(null);
  const [contentId, setContentId] = useState(null);
  const [glassId, setGlassId] = useState(null);
  const [panelId, setPanelId] = useState(null);
  const [materialTypeId, setMaterialTypeId] = useState(null);
  const [fillingId, setFillingId] = useState(null);
  const [parents, setParents] = useState([]);
  const [productList, setProductList] = useState([]);
  const [materialTypeList, setMaterialTypeList] = useState([]);
  const [fillingList, setFillingList] = useState([]);
  const [enabled, setEnabled] = useState(false);
  const [isDefault, setIsDefault] = useState(false);
  const [supplierId, setSupplierId] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [visibility, setVisibility] = useState("PUBLIC");
  const [slidingType, setSlidingType] = useState("NONE");
  const [maxTrackCount, setMaxTrackCount] = useState("");
  const [slidingTypeList, setSlidingTypeList] = useState(SLIDING_TYPE_FALLBACK);
  const [isTesting, setIsTesting] = useState(false);
  const [sashClearance, setSashClearance] = useState("");
  const [clientScope, setClientScope] = useState("ALL");
  const [clientScopeList, setClientScopeList] = useState(CLIENT_SCOPE_FALLBACK);
  const [specifications, setSpecifications] = useState([]);
  const [image, setImage] = useState({
    preview: PLACEHOLDER_IMAGE,
    data: null,
  });
  const fileInputRef = useRef(null);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [cropSource, setCropSource] = useState(null);
  const [cropSourceType, setCropSourceType] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setCropSource(URL.createObjectURL(file));
    setCropSourceType(file.type);
    setCropModalOpen(true);
  };

  const handleCropComplete = (file) => {
    setImage({
      preview: URL.createObjectURL(file),
      data: file,
    });
  };

  const handleChooseAnother = () => {
    fileInputRef.current?.click();
  };

  const fetchSuppliers = async () => {
    const response = await fetchDataSupplier(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/supplier/table`,
      token,
      {
        draw: 1,
        start: 0,
        length: 1000,
        recordsTotal: 0,
        columns: [],
        order: [{ column: "name", dir: "ASC" }],
        search: { value: "", regex: false },
        filter: {},
      },
    );
    if (response.success) {
      setSuppliers(response.data.data.map((s) => ({ id: s.id, name: s.name })));
    }
  };

  const fetchTreeList = async () => {
    const response = await getList(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/list/tree`,
      token,
    );
    if (response.success) {
      setParents(response.data);
    } else {
      navigate("/error", {
        state: {
          status: response.status,
          message: response.message ? response.message : null,
        },
      });
    }
  };

  const fetchGlassList = async () => {
    const response = await getList(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/article/filling`,
      token,
    );
    if (response.success) {
      setProductList(response.data);
    } /* else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }*/
  };
  const fetchFillingList = async () => {
    const response = await getList(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/filling/group/list`,
      token,
    );
    if (response.success) {
      setFillingList(response.data);
    } /*else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }*/
  };
  const fetchMaterialType = async () => {
    const response = await getList(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/material-type/list`,
      token,
    );
    if (response.success) {
      setMaterialTypeList(response.data);
    } /*else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }*/
  };

  const fetchSlidingTypeList = async () => {
    const response = await getList(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/enum/sliding/type`,
      token,
    );
    if (response.success && Array.isArray(response.data)) {
      setSlidingTypeList(response.data.map((item) => item.name));
    }
  };

  const fetchClientScopeList = async () => {
    const response = await getList(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/enum/client/scope`,
      token,
    );
    if (response.success && Array.isArray(response.data)) {
      setClientScopeList(response.data.map((item) => item.name));
    }
  };

  const fetchDataById = async () => {
    const response = await getItem(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/${rowId}`,
      token,
    );
    if (response.success) {
      setEnabled(response.data.isVisible);
      setIsDefault(response.data.isDefault);
      setName(response.data.name);
      setGlassId(response.data.defaultGlassId);
      setPanelId(response.data.defaultPanelId);
      setMaterialTypeId(response.data.materialTypeId);
      setFillingId(response.data.fillingGroupId);
      const fullInfo = response.data.profileSystemFullInfo;
      setContentId(fullInfo?.id ? fullInfo.id : null);
      setSpecifications(fullInfo?.characteristics || []);
      setSupplierId(response.data.supplierId || null);
      setVisibility(response.data.visibility || "PUBLIC");
      setSlidingType(response.data.slidingType || "NONE");
      setIsTesting(Boolean(response.data.isTesting));
      setSashClearance(
        response.data.sashClearance == null ? "" : String(response.data.sashClearance),
      );
      setClientScope(response.data.clientScope || "ALL");
      setMaxTrackCount(
        response.data.maxTrackCount == null ? "" : String(response.data.maxTrackCount),
      );
      setImage({
        preview: response.data.imageId
          ? `${process.env.REACT_APP_HOST_BASE_URL}/v1/file/profile/${response?.data?.imageId}`
          : PLACEHOLDER_IMAGE,
        data: null,
      });
    } else {
      navigate("/error", {
        state: {
          status: response.status,
          message: response.message ? response.message : null,
        },
      });
    }
  };

  function onChangeTree(value) {
    setParentId(value);
  }

  function handleChangeProduct(value) {
    setGlassId(value.id);
  }
  function handleChangePanel(value) {
    setPanelId(value.id);
  }
  function handleMaterialType(value) {
    setMaterialTypeId(value.id);
  }

  function handleChangeFilling(value) {
    setFillingId(value.id);
  }

  const handleSupplierChange = (value) => {
    setSelectedSupplier(value);
    setSupplierId(value ? value.id : null);
  };

  const handleSpecRowChange = (index, field, value) => {
    setSpecifications((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [field]: value } : row)),
    );
  };

  const addSpecRow = () => {
    setSpecifications((prev) => [...prev, { key: "", value: "" }]);
  };

  const removeSpecRow = (index) => {
    setSpecifications((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (evt) => {
    evt.preventDefault();

    const hasIncompleteSpecRow = specifications.some(
      (row) => !row.key || row.key.trim() === "",
    );
    if (hasIncompleteSpecRow) {
      toast.error("Xususiyat qatorlarida kalit tanlanmagan yoki yaratilmagan", {
        position: "bottom-right",
        autoClose: 5000,
        closeOnClick: true,
      });
      return;
    }

    const response = await saveProfileSystem(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system`,
      token,
      {
        id: rowId ? rowId : null,
        name: name,
        parentId: parentId,
        defaultGlassId: glassId,
        defaultPanelId: panelId,
        fillingGroupId: fillingId,
        materialTypeId: materialTypeId,
        isVisible: enabled,
        isDefault: isDefault,
        supplierId: supplierId,
        visibility: visibility,
        slidingType: slidingType,
        isTesting: isTesting,
        clientScope: clientScope,
        // bo'sh — global sash.clearance (12)
        sashClearance: sashClearance !== "" ? Number(sashClearance) : null,
        // MULTI_TRACK_FRAME da chegara rama profillaridan hisoblanadi — yubormaymiz
        maxTrackCount:
          slidingType === "FRAME_PER_TRACK" && maxTrackCount !== ""
            ? Number(maxTrackCount)
            : null,
        specifications: specifications,
      },
      image.data,
    );
    if (response.success) {
      const entityId = rowId ? parseInt(rowId) : response.data?.id;

      if (specifications.length > 0) {
        const fullInfoResponse = await saveItem(
          `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile-system-full-info`,
          token,
          {
            id: contentId,
            profileSystemId: entityId,
            characteristics: specifications,
          },
        );
        if (!fullInfoResponse.success) {
          navigate("/error", {
            state: {
              status: fullInfoResponse.status,
              message: fullInfoResponse.message
                ? fullInfoResponse.message
                : null,
            },
          });
          return;
        }
      }

      if (translationRef.current && entityId) {
        try {
          await translationRef.current.save(entityId);
        } catch (err) {
          toast.error(t("action.translation_save_error"), {
            position: "bottom-right",
            autoClose: 5000,
            closeOnClick: true,
          });
          return;
        }
      }
      setParentId(null);
      fetchTreeList();
      fetchData();
      setOpen(false);
      toast.success(t("action.add_success"), {
        position: "bottom-right",
        autoClose: 3000,
        closeOnClick: true,
        className: "add-success",
      });
    } else {
      navigate("/error", {
        state: {
          status: response.status,
          message: response.message ? response.message : null,
        },
      });
    }
  };

  useEffect(() => {
    fetchTreeList();
    fetchGlassList();
    fetchMaterialType();
    fetchFillingList();
    fetchSuppliers();
    fetchSlidingTypeList();
    fetchClientScopeList();
    if (rowId == null) {
      setName("");
      setEnabled(false);
      setIsDefault(false);
      setSupplierId(null);
      setSelectedSupplier(null);
      setVisibility("PUBLIC");
      setSlidingType("NONE");
      setMaxTrackCount("");
      setIsTesting(false);
      setClientScope("ALL");
      setSashClearance("");
      setSpecifications([]);
      setContentId(null);
      setImage({ preview: PLACEHOLDER_IMAGE, data: null });
    }
    if (rowId) {
      fetchDataById();
    }
  }, [open]);

  useEffect(() => {
    if (suppliers.length > 0 && supplierId) {
      const found = suppliers.find((s) => s.id === supplierId);
      setSelectedSupplier(found || null);
    }
  }, [suppliers, supplierId]);

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative w-full text-left transition-all transform bg-white rounded-xl shadow-2xl sm:my-8 sm:w-full sm:max-w-7xl overflow-hidden">
                <form
                  onSubmit={handleSubmit}
                  className="flex flex-col max-h-[85vh]"
                >
                  <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      {t("add_profile_system")}
                    </Dialog.Title>
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="text-gray-400 rounded-md hover:text-gray-500 focus:outline-none"
                    >
                      <span className="sr-only">{t("cancel")}</span>
                      <XMarkIcon className="w-6 h-6" aria-hidden="true" />
                    </button>
                  </div>

                  <div className="flex-1 px-6 py-5 overflow-y-auto">
                    <div className="space-y-5">
                      <div>
                        <label
                          htmlFor="name"
                          className="block text-sm font-medium text-gray-700 mb-2"
                        >
                          {t("name")}
                        </label>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          required
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                          className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {t("profile_system_list")}
                        </label>
                        <TreeSelectComponent
                          onChange={onChangeTree}
                          tree={parents}
                          treeSelectedId={parentId}
                          disable={rowId ? true : false}
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 gap-4 pt-5 mt-5 border-t border-gray-200 sm:grid-cols-3">
                      <ComboboxComponent
                        label={t("profile_system_default_filling")}
                        data={fillingList}
                        item={
                          fillingId
                            ? fillingList.find((item) => item.id === fillingId)
                            : null
                        }
                        onChange={handleChangeFilling}
                      />
                      <ComboboxComponent
                        label={t("DOUBLE_GLAZING")}
                        data={productList}
                        item={
                          glassId
                            ? productList.find((item) => item.id === glassId)
                            : null
                        }
                        onChange={handleChangeProduct}
                      />
                      <ComboboxComponent
                        label={t("SANDWICH")}
                        data={productList}
                        item={
                          panelId
                            ? productList.find((item) => item.id === panelId)
                            : null
                        }
                        onChange={handleChangePanel}
                      />
                      <ComboboxComponent
                        label={t("material_type")}
                        data={materialTypeList}
                        item={
                          materialTypeId
                            ? materialTypeList.find(
                                (item) => item.id === materialTypeId,
                              )
                            : null
                        }
                        onChange={handleMaterialType}
                      />
                      <ComboboxComponent
                        label={t("supplier")}
                        data={suppliers}
                        item={selectedSupplier}
                        onChange={handleSupplierChange}
                      />
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">
                          {t("visibility")}
                        </label>
                        <select
                          value={visibility}
                          onChange={(e) => setVisibility(e.target.value)}
                          className="block w-full py-2 px-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        >
                          {VISIBILITY_OPTIONS.map((opt) => (
                            <option key={opt} value={opt}>
                              {t(opt)}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">
                          {t("sliding_type")}
                        </label>
                        <select
                          value={slidingType}
                          onChange={(e) => setSlidingType(e.target.value)}
                          className="block w-full py-2 px-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        >
                          {slidingTypeList.map((opt) => (
                            <option key={opt} value={opt}>
                              {t(`sliding_type_option.${opt}`)}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">
                          {t("client_scope")}
                        </label>
                        <select
                          value={clientScope}
                          onChange={(e) => setClientScope(e.target.value)}
                          className="block w-full py-2 px-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        >
                          {clientScopeList.map((opt) => (
                            <option key={opt} value={opt}>
                              {t(`client_scope_option.${opt}`)}
                            </option>
                          ))}
                        </select>
                        <p className="mt-1 text-xs text-gray-500">
                          {t("client_scope_hint")}
                        </p>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">
                          {t("sash_clearance")}
                        </label>
                        <input
                          type="number"
                          min="0"
                          step="0.1"
                          value={sashClearance}
                          placeholder={String(DEFAULT_SASH_CLEARANCE)}
                          onChange={(e) => setSashClearance(e.target.value)}
                          className="block w-full py-2 px-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                        <p className="mt-1 text-xs text-gray-500">
                          {t("sash_clearance_hint")}
                        </p>
                      </div>
                      {slidingType !== "NONE" && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-3">
                            {t("max_track_count")}
                          </label>
                          <input
                            type="number"
                            min="1"
                            max="10"
                            value={
                              slidingType === "MULTI_TRACK_FRAME" ? "" : maxTrackCount
                            }
                            disabled={slidingType === "MULTI_TRACK_FRAME"}
                            placeholder={String(DEFAULT_MAX_TRACK_COUNT)}
                            onChange={(e) => setMaxTrackCount(e.target.value)}
                            className="block w-full py-2 px-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:bg-gray-100 disabled:text-gray-400"
                          />
                          <p className="mt-1 text-xs text-gray-500">
                            {slidingType === "MULTI_TRACK_FRAME"
                              ? t("max_track_count_from_frames")
                              : t("max_track_count_hint")}
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center gap-8 pt-5 mt-5 border-t border-gray-200">
                      <ToggleWithLabel
                        label={t("visible")}
                        enabled={enabled}
                        setEnabled={setEnabled}
                      />
                      <ToggleWithLabel
                        label={t("default")}
                        enabled={isDefault}
                        setEnabled={setIsDefault}
                      />
                      <ToggleWithLabel
                        label={t("test_mode")}
                        enabled={isTesting}
                        setEnabled={setIsTesting}
                      />
                    </div>

                    <div className="pt-5 mt-5 border-t border-gray-200">
                      <TranslationTable
                        ref={translationRef}
                        entityType="PROFILE_SYSTEM"
                        entityId={rowId ? parseInt(rowId) : null}
                        fields={PROFILE_SYSTEM_TRANSLATION_FIELDS}
                        defaultValues={{ NAME: name }}
                      />
                    </div>
                    <div className="pt-5 mt-5 border-t border-gray-200">
                      <div className="flex flex-col gap-6 sm:flex-row sm:items-start">
                        <div>
                          <label
                            htmlFor="profile-system-file-upload"
                            className="block mb-2 text-sm font-medium text-gray-700"
                          >
                            {t("content_image")}
                          </label>
                          <div className="inline-flex w-56 px-4 pt-3 pb-4 border-2 border-gray-300 border-dashed rounded-md">
                            <div className="w-full space-y-1 text-center">
                              <div className="flex justify-center mb-2">
                                <img
                                  src={image.preview}
                                  className="rounded-lg"
                                  width="100px"
                                  height="50px"
                                  alt="profile-system"
                                />
                              </div>
                              <div className="flex flex-wrap justify-center gap-1 text-sm text-gray-600">
                                <label
                                  htmlFor="profile-system-file-upload"
                                  className="relative font-medium text-indigo-600 bg-white rounded-md cursor-pointer hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                                >
                                  <span>{t("upload_file")}</span>
                                  <input
                                    id="profile-system-file-upload"
                                    name="profile-system-file-upload"
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputRef}
                                    className="sr-only"
                                    onChange={handleFileChange}
                                  />
                                </label>
                                <p>{t("upload_file_text1")}</p>
                              </div>
                              <p className="text-xs text-gray-500">
                                {t("upload_file_text2")}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="flex-1">
                          <label className="block mb-2 text-sm font-medium text-gray-700">
                            Xususiyatlar
                          </label>
                          <div className="space-y-2">
                            {specifications.map((row, index) => (
                              <div
                                key={index}
                                className="flex items-center gap-2"
                              >
                                <div className="w-1/2">
                                  <TranslationKeySelect
                                    value={row.key}
                                    onChange={(key) =>
                                      handleSpecRowChange(index, "key", key)
                                    }
                                  />
                                </div>
                                <div className="w-1/2">
                                  <TranslationKeySelect
                                    value={row.value}
                                    onChange={(key) =>
                                      handleSpecRowChange(index, "value", key)
                                    }
                                  />
                                </div>
                                <button
                                  type="button"
                                  onClick={() => removeSpecRow(index)}
                                  className="p-2 text-gray-400 hover:text-red-500 focus:outline-none"
                                >
                                  <TrashIcon className="w-5 h-5" />
                                </button>
                              </div>
                            ))}
                            <button
                              type="button"
                              onClick={addSpecRow}
                              className="inline-flex items-center gap-1 text-sm font-medium text-indigo-600 hover:text-indigo-700"
                            >
                              <PlusIcon className="w-4 h-4" />
                              Qator qo'shish
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50 rounded-b-xl">
                    <button
                      type="button"
                      className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      {t("cancel")}
                    </button>
                    <button
                      type="submit"
                      className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      {t("save")}
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
      </Transition.Root>
      <ImageCropModal
        key={cropSource}
        open={cropModalOpen}
        setOpen={setCropModalOpen}
        imageSrc={cropSource}
        mimeType={cropSourceType}
        onCropComplete={handleCropComplete}
        onChooseAnother={handleChooseAnother}
      />
    </>
  );
}
